const states = [
    {
        fullState: 'Alabama',
        state: 'AL'
    },
    {
        fullState: 'Alaska',
        state: 'AK'
    },
    {
        fullState: 'Arizona',
        state: 'AZ'
    },
    {
        fullState: 'Arkansas',
        state: 'AR'
    },
    {
        fullState: 'California',
        state: 'CA'
    },
    {
        fullState: 'Colorado',
        state: 'CO'
    },
    {
        fullState: 'Connecticut',
        state: 'CT'
    },
    {
        fullState: 'Delaware',
        state: 'DE'
    },
    {
        fullState: 'District of Columbia',
        state: 'DC'
    },
    {
        fullState: 'Florida',
        state: 'FL'
    },
    {
        fullState: 'Georgia',
        state: 'GA'
    },
    {
        fullState: 'Hawaii',
        state: 'HI'
    },
    {
        fullState: 'Idaho',
        state: 'ID'
    },
    {
        fullState: 'Illinois',
        state: 'IL'
    },
    {
        fullState: 'Indiana',
        state: 'IN'
    },
    {
        fullState: 'Iowa',
        state: 'IA'
    },
    {
        fullState: 'Kansas',
        state: 'KS'
    },
    {
        fullState: 'Kentucky',
        state: 'KY'
    },
    {
        fullState: 'Louisiana',
        state: 'LA'
    },
    {
        fullState: 'Maine',
        state: 'ME'
    },
    {
        fullState: 'Maryland',
        state: 'MD'
    },
    {
        fullState: 'Massachusetts',
        state: 'MA'
    },
    {
        fullState: 'Michigan',
        state: 'MI'
    },
    {
        fullState: 'Minnesota',
        state: 'MN'
    },
    {
        fullState: 'Mississippi',
        state: 'MS'
    },
    {
        fullState: 'Missouri',
        state: 'MO'
    },
    {
        fullState: 'Montana',
        state: 'MT'
    },
    {
        fullState: 'Nebraska',
        state: 'NE'
    },
    {
        fullState: 'Nevada',
        state: 'NV'
    },
    {
        fullState: 'New Hampshire',
        state: 'NH'
    },
    {
        fullState: 'New Jersey',
        state: 'NJ'
    },
    {
        fullState: 'New Mexico',
        state: 'NM'
    },
    {
        fullState: 'New York',
        state: 'NY'
    },
    {
        fullState: 'North Carolina',
        state: 'NC'
    },
    {
        fullState: 'North Dakota',
        state: 'ND'
    },
    {
        fullState: 'Ohio',
        state: 'OH'
    },
    {
        fullState: 'Oklahoma',
        state: 'OK'
    },
    {
        fullState: 'Oregon',
        state: 'OR'
    },
    {
        fullState: 'Pennsylvania',
        state: 'PA'
    },
    {
        fullState: 'Puerto Rico',
        state: 'PR'
    },
    {
        fullState: 'Rhode Island',
        state: 'RI'
    },
    {
        fullState: 'South Carolina',
        state: 'SC'
    },
    {
        fullState: 'South Dakota',
        state: 'SD'
    },
    {
        fullState: 'Tennessee',
        state: 'TN'
    },
    {
        fullState: 'Texas',
        state: 'TX'
    },
    {
        fullState: 'Utah',
        state: 'UT'
    },
    {
        fullState: 'Vermont',
        state: 'VT'
    },
    {
        fullState: 'Virginia',
        state: 'VA'
    },
    {
        fullState: 'Washington',
        state: 'WA'
    },
    {
        fullState: 'West Virginia',
        state: 'WV'
    },
    {
        fullState: 'Wisconsin',
        state: 'WI'
    },
    {
        fullState: 'Wyoming',
        state: 'WY'
    }
];
export default states;
export const publicationStates = [{fullState: 'National', state: 'NA'}, ...states];
export const shippingStates = [
    {
        fullState: 'Armed Forces Americas',
        state: 'AA',
    },
    {
        fullState: 'Armed Forces Europe',
        state: 'AE',
    },
    {
        fullState: 'Armed Forces Pacific',
        state: 'AP',
    },
    ...states
];

export const optionStates = (function() {
    return states.map(({fullState, state}) => {
        return {value: state, text: fullState};
    });
})()
